import { render, staticRenderFns } from "./ProfilePassword.vue?vue&type=template&id=cf9e8408"
import script from "./ProfilePassword.vue?vue&type=script&lang=js"
export * from "./ProfilePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports